import type { PlatinumData } from '../../types/carbon/models/PlatinumData'

/**
 * The slices the pie draws, biggest first: tag values with at least one post.
 * Colours go out in this order, so the eight biggest slices each get their own
 * and a value with one or two posts is the one left grey.
 */
export function drawnSlices(data: PlatinumData | null): string[] {
  const vecs = data?.side?.vecs ?? []
  const rows = data?.cells?.rows ?? []
  return vecs
    .map((v, i) => ({ label: v.label ?? '', n: rows[i]?.cell?.[0]?.freq ?? 0 }))
    .filter((s) => s.n > 0)
    .sort((a, b) => b.n - a.n)
    .map((s) => s.label)
}
